import $fn from '@/utils/fn.ts';
import httpApi from '@/apis/httpApi'
import http from "@/utils/http.js"

// 登出
export const logout = () => $fn.httpPost({
	url: httpApi.user.logout,
})

// 获取用户信息
export const getUserInfo = (): any => {
	return $fn.httpPost({
		url: httpApi.user.getInfo,
	})
}

// 获取用户信息
export const getMenu = (): any => $fn.httpPost({
	url: httpApi.user.getMenu,
})

interface GetId {
	id: string
}
export const getUserInfoDemo = (data: GetId): any => $fn.httpPost({
	url: httpApi.user.getUserInfo,
	data
})

// 登录
interface LoginJson {
	username: string,
	password: string,
}
export const login = (data: LoginJson): any => http.httpPost({
	url: httpApi.user.login,
	data
})
// 盒子登录
interface tokenLoginJson {
	token: string,
	game_id: string,
}
export const tokenlogin = (data: tokenLoginJson): any => http.httpPost({
	url: httpApi.user.tokenLogin,
	data,
})

// 获取短信接口
interface SendsmsJson {
	phone: string,
}
export const sendsms = (data: SendsmsJson): any => http.httpPost({
	url: httpApi.user.sendsms,
	data,
})

// 手机验证码登陆
interface PhoneLoginJson {
	phone: string,
	code: string,
}
export const phoneLogin = (data: PhoneLoginJson): any => http.httpPost({
	url: httpApi.user.phoneLogin,
	data,
})

// 用户实名认证
interface IdentificationJson {
	name: string,
	idcard: string,
}
export const identification = (data: IdentificationJson): any => http.httpPost({
	url: httpApi.user.identification,
	data,
})

// 用户名密码注册
interface RegJson {
	username: string,
	password: string,
	// jl_report: string
}
export const reg = (data: { password: any; username: string }): any => http.httpPost({
	url: httpApi.user.reg,
	data,
})

// 客服
export const getKfQqGroup = () => http.httpPost({
	url: httpApi.user.getKfQqGroup,
})

// 游戏隐私协议
export const protocol = (json) => http.httpPost({
	url: httpApi.user.protocol,
	json
})

interface CodeJson {
	code: string,
}
export const wxjsapipay = (data:CodeJson): any => http.httpPost({
	url: httpApi.pay.wxjsapipay,
	data
})

interface ReportJson {
	_device_info: string
}
export const ActivateJlReport = (data:ReportJson): any => http.httpPost({
	url: httpApi.user.ActivateJlReport,
	data
})
export const LoadSdkData = (data): any => http.httpPost({
	url: httpApi.user.loadSdkData,
	data
})
